import React, { useState } from "react";

import { useReimbursement } from "@hooks/reimbursments/useReimbursement";
import {
  SvgMenuExpenses,
  SvgIndicatorResponse,
  SvgAmount,
  SvgUpdateAssignationIcon,
} from "@routes/IconeSvg";
import { isEqual } from "lodash";
import moment from "moment-timezone";

import SharedViewFile from "@components/modals/SharedViewFile";
import { FloatButton } from "@components/tailwindComponents";
import { Status } from "@components/tailwindComponents";
import DeleteItemButton from "@components/tailwindComponents/DeleteItemButton";
import BlackTooltip from "@components/tooltip/BlackTooltip";

import {
  getAmount,
} from "@helpers/_functions";
import { getStatusColor } from "@helpers/_functions";

import ModalComments from "../../components/modals/Comments";
import ModalDelete from "../../components/modals/DeleteReimburment";
import ModalMileinageRequest from "../../components/modals/MileageRequest";
import ModalNewRequest from "../../components/modals/NewRequest";
import TooltipExpenses from "@entreprise/ExpensesNotes/components/ToolTipExpenses";
import Description from "@components/tailwindComponents/Description";

export default function Items({ reimbursment, t, key, i18n }) {
  const { onDelete } = useReimbursement();
  const [showModalComments, setShowModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [sharedViewFile, setShowFile] = useState(false);
  const [file, setFile] = useState({});
  const [showModalRequest, setShowNewRequest] = useState(false);
  const [showModalMileiageRequest, setShowNewMileaigeRequest] = useState(false);
  const [wait, setWait] = useState(false);

  const onToggleComments = () => {
    setShowModal(!showModalComments);
  };

  const onClickDelete = () => {
    setShowDelete(!showDelete);
  };
  const onSave = async () => {
    console.log("Wait : ", wait);
    if (!wait) {
      setWait(true);
      const response = await onDelete(reimbursment?._id);
      if (response) {
        setShowDelete(!showDelete);
      }
      setWait(false);
    }
  };
  const onClickShowFile = (file) => {
    setShowFile(!sharedViewFile);
    setFile(file);
  };

  const OnClickEditReimbursment = () => {
    if (isEqual(reimbursment?.type, "mileage")) {
      setShowNewMileaigeRequest(
        (_showModalMileiageRequest) => !_showModalMileiageRequest,
      );
    } else {
      setShowNewRequest((_showModalRequest) => !_showModalRequest);
    }
  };

  return (
    <>
      <tr
        className="arh-border-x-0 arh-border-b arh-border-t-0 arh-border-solid arh-border-borderTable hover:arh-bg-greyColor"
        key={key}
      >
        <td className="arh-px-4 arh-py-3 ">
          <BlackTooltip
            title={
              <p
                className="arh-m-0 arh-w-full"
                style={{
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitBoxOrient: "vertical",
                  WebkitLineClamp: 5,
                  fontSize: "12px",
                }}
              >
                {reimbursment?.category?.name}
              </p>
            }
            placement="top"
          >
            <span className="arh-line-clamp-3 arh-font-poppins arh-text-xs arh-font-medium arh-text-darkGreyColor arh-w-fit">
              {reimbursment?.category?.name}
            </span>
          </BlackTooltip>
        </td>
        <td className="arh-px-4 arh-py-3">
          <div className="arh-flex arh-justify-between arh-items-center">
            <span className="arh-font-poppins arh-font-medium arh-text-xs arh-text-darkGreyColor arh-truncate">
              {reimbursment?.devise || "$ "} {getAmount(reimbursment)}
            </span>
            <BlackTooltip
              title={
                <TooltipExpenses
                  reimbursment={reimbursment}
                />
              }
              placement="top"
            >
              <span className="arh-shrink-0">{SvgAmount()}</span>
            </BlackTooltip>
          </div>
        </td>
        <td className="arh-whitespace-nowrap arh-px-4 arh-py-3 arh-font-poppins arh-text-xs arh-font-medium arh-text-darkGreyColor">
          {moment(reimbursment?.date, "YYYY-MM-DD")
            .locale(i18n.language)
            .format("LL"
            )}
        </td>
        <td className="arh-px-4 arh-py-3 arh-align-middle">
          {reimbursment?.description ? (
            <BlackTooltip title={reimbursment?.description} placement="top">
              <span className="arh-line-clamp-3 arh-font-poppins arh-text-xs arh-font-medium arh-text-darkGreyColor arh-w-fit">
                {reimbursment?.description || "-"}
              </span>
            </BlackTooltip>
          ) : (
            "-"
          )}
        </td>
        <td
          className="arh-px-4 arh-py-3 arh-align-middle"
          onClick={onToggleComments}
        >
          <div className="arh-flex arh-h-full arh-w-full arh-items-center arh-justify-between arh-space-x-4">
            {reimbursment?.commentSended || reimbursment?.commentReceived ? (
              <Description
                description={reimbursment?.commentSended || reimbursment?.commentReceived}
                className="arh-font-poppins arh-font-medium arh-text-xs arh-mb-0 arh-cursor-pointer"
                textColor="arh-text-darkGreyColor"
              />
            ) : (
              "-"
            )}
            <span>
              {reimbursment?.commentReceived ? SvgIndicatorResponse() : ""}
            </span>
          </div>
        </td>
        <td className="arh-px-4 arh-py-3 arh-font-poppins arh-text-xs arh-font-medium arh-text-darkGreyColor">
          {reimbursment?.files?.length
            ? reimbursment.files.map((file, index) => (
              <BlackTooltip
                title={file?.filename}
                placement="top"
                key={file._id}
              >
                <div
                  className="arh-flex arh-w-full arh-cursor-pointer arh-items-center arh-justify-start arh-space-x-2"
                  onClick={() => onClickShowFile(file)}
                >
                  <span>{SvgMenuExpenses()}</span>
                  <span className="arh-block arh-w-full arh-truncate">
                    {file?.filename}
                  </span>
                </div>
              </BlackTooltip>
            ))
            : "-"}
        </td>
        <td className="arh-px-4 arh-py-3 tablet-850:arh-px-2">
          <div className="arh-flex arh-w-full arh-items-center arh-justify-between arh-gap-2">
            <div className="arh-flex arh-min-w-0 arh-flex-1 arh-items-center arh-rounded arh-border arh-border-solid arh-border-greyBorderInput arh-px-6 arh-py-3 desktop-middle:arh-px-2">
              <Status
                className={`arh-mr-[10%] ${getStatusColor(
                  reimbursment.status,
                )}`}
              />
              <span className="arh-whitespace-nowrap arh-align-middle arh-font-poppins arh-text-xs arh-font-medium arh-text-darkGreyColor tablet-850:arh-truncate tablet-850:arh-whitespace-nowrap">
                {t(reimbursment.status)}
              </span>
            </div>
            <div className="arh-flex arh-shrink-0 arh-items-center arh-space-x-1">
              {isEqual(reimbursment.status, "waiting") || isEqual(reimbursment.status, "draft") ? (
                <>
                  <FloatButton
                    size="arh-w-7 arh-h-7"
                    onClick={OnClickEditReimbursment}
                    color="arh-bg-transparent hover:arh-bg-gray-200 active:arh-bg-greyActive"
                  >
                    <SvgUpdateAssignationIcon />
                  </FloatButton>
                  <DeleteItemButton onClick={onClickDelete} />
                </>
              ) : (
                ""
              )}
            </div>
          </div>
        </td>
      </tr>
      <ModalComments
        show={showModalComments}
        onClickClose={onToggleComments}
        commentSended={reimbursment?.commentSended}
        commentReceived={reimbursment?.commentReceived}
        statusTitle={reimbursment.status}
        t={t}
      />
      <ModalDelete
        onClickClose={onClickDelete}
        onDeleteClick={onSave}
        show={showDelete}
        isDeleting={wait}
        t={t}
      />
      <ModalNewRequest
        show={showModalRequest}
        onClickClose={OnClickEditReimbursment}
        reimbursment={reimbursment}
      />

      <ModalMileinageRequest
        isOpen={showModalMileiageRequest}
        onClickClose={OnClickEditReimbursment}
        t={t}
        reimbursment={reimbursment}
      />
      <SharedViewFile
        onClickClose={onClickShowFile}
        show={sharedViewFile}
        file={file}
        t={t}
      />
    </>
  );
}
